<div style="width: 570px; height: 610px;padding: 10px" data-cy="enum-dialog-container">
 <div class="section-header-title" data-cy="enum-title-text">
  Edit Options List: {{this.validValue_Name}}  <span *ngIf="validValue_isSystem==true" data-cy="enum-system-indicator">-System</span>
</div>



<dx-data-grid
  id="gridContainer"
  data-cy="enum-datagrid"
  [height]="500"
  [dataSource]="ldata"
  keyExpr="ValidValueItemId"
  [showBorders]="true"
>
  <dxi-column dataField="ItemDisplayValue" caption="Display Value" [width]="250" [setCellValue]="onSetValueItemDisplayValue" data-cy="enum-column-display"></dxi-column>
  <dxi-column dataField="ItemSValue" caption="Abbreviation" [width]="100" [setCellValue]="onSetValueItemSValue" data-cy="enum-column-abbrev"></dxi-column>
  <dxi-column dataField="isSystem" caption="System" width="80" [allowEditing]="false" data-cy="enum-column-system"></dxi-column>
  <dxi-column dataField="xauditDeleted" caption="Deleted" [width]="80" [allowEditing]="true" [setCellValue]="onSetValuexauditDeleted" data-cy="enum-column-deleted"></dxi-column>

  <dxo-row-dragging
    [allowReordering]="true"
    [onReorder]="onReorder"
    [showDragIcons]="true"
    data-cy="enum-row-dragging"
  ></dxo-row-dragging>

  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-editing
    mode="cell"
    [allowUpdating]="true"
    [allowAdding]="true"
    [allowDeleting]="false"
    [selectTextOnEditStart]="true"
    startEditAction='click'
    data-cy="enum-editing-options"
  >
  </dxo-editing>

  <dxo-toolbar data-cy="enum-toolbar">
    <dxi-item name="addRowButton" showText="always">
      <dx-button
        (onClick)="addRecord()"
        icon="add"
        text="Add New Value"
        data-cy="enum-add-button"
      />
    </dxi-item>
  </dxo-toolbar>

</dx-data-grid>

  <div data-cy="enum-footer-section">
    <dx-button style="float: right" width="100" text="OK" (onClick)="onClose()" data-cy="enum-ok-button"></dx-button>
<!--    <dx-button style="float: right" width="100" text="Cancel" (onClick)="onCancel()"></dx-button>-->
  </div>
</div>


<!--

<div style="width: 800px; height: 600px;">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;">
      <div class="section-header-title">
        Edit Options List: {{this.validValue_Name}}  <span *ngIf="validValue_isSystem==true">-System</span>
      </div>
      <div style="flex: 1;"></div>
    </div>

    <div class="section-content" style="flex: 1;">
      <div style="height: 496px; max-height: 496px; overflow-y: auto;">
        <tdo-table #table [isDragAndDrop]="true" [isSearchable]="false" [dataSource]="data" [isAddButtonEnabled]="!validValue_isSystem" (rowSelected)="onRowSelected($event)"
                   (addClicked)="onAddEnumItem($event)" (rowsReordered)="onRowsReordered($event)">
          <tdo-table-column displayName="Order" propertyName="ItemOrder" [rowTemplate]="order">
            <ng-template #order let-row>
              {{row.ItemOrder}}
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Display Value" propertyName="ItemDisplayValue" [rowTemplate]="displayValue">
            <ng-template #displayValue let-row>
              <span *ngIf="validValue_isSystem==true ||  row.model.isSystem==true" >{{row.model.ItemDisplayValue}}</span>
              <input *ngIf="validValue_isSystem==false && row.model.isSystem==false" [value]="row.model.ItemDisplayValue" (appInputFinished)="selectedValidValueItem.ItemDisplayValue = $event; this.onDisplayNameUpdate($event, row, selectedValidValueItem);" />
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Abbreviation" propertyName="ItemSValue" [rowTemplate]="abbreviation">
            <ng-template #abbreviation let-row>
                <span *ngIf="validValue_isSystem==true ||  row.model.isSystem==true" >{{row.model.ItemSValue}}</span>
                <input *ngIf="validValue_isSystem==false && row.model.isSystem==false" style="width: 90%; border-radius: 6px; border: 1px solid var(--tdo-secondary); outline: unset; margin-right: 4px;" [value]="row.ItemSValue" (appInputFinished)="onAbbrevUpdate($event, row);" />
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="delete1">
            <ng-template #delete1 let-row>
              <span *ngIf="row.model.isSystem==true">System</span>
              <div *ngIf="validValue_isSystem==false &&  row.model.isSystem==false" (click)="onDeleteClick(row.model)" matTooltip="Delete" style="text-align: right; cursor: pointer; color: var(--tdo-secondary);"><mat-icon>delete</mat-icon></div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    </div>

    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;">Cancel</button>

      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;">Ok</button>
    </div>
  </div>
</div>
-->

